<template>
  <section class="buy-quote-container">
    <template v-if="!isSMEProduct">
      <div v-show="step !== 2">
        <h2>{{title}}</h2>
        <template v-if="!isRenew">
          <div
            v-show="step !== 0"
            class="abs-top-right">
            <v-button @click="changeStep(-1)">Previous</v-button>
            <v-button
              type="primary"
              @click="handlerNext">Next</v-button>
          </div>
        </template>

        <div
          v-else
          class="abs-top-right">
          <v-button @click="handleBack">Back</v-button>
        </div>
      </div>
      <div
        v-show="step === 0"
        class="main-container">
        <div class="left">
          <div
            v-if="!isRefer"
            class="card">
            <!--          <promo-code-->
            <!--            :notApply="true"-->
            <!--            :orderId="orderId"-->
            <!--            :customerId="customerId"-->
            <!--            :applyCode="code"-->
            <!--            @check-code="handlerGetAllQuote" />-->
            <code-select
              :is-fina="isFina"
              :notApply="true"
              :orderId="orderId"
              :isQuote="false"
              :customerId="customerId"
              :customer="customer"
              :is-small="true"
              @check-code="handlerGetAllQuote"></code-select>
          <!-- <div class="form-item">
            <span>Promo Code</span>
            <v-input />
          </div>
          <v-button type="primary">Apply</v-button> -->
          </div>
          <div
            v-if="type != 20 && productId == 11"
            class="card">
            <div class="form-item">
              <span>Insurance Type</span>
              <v-checkbox-group
                v-model="filterData.trm_of_cvr"
                :list="coverTypeOptions"
                @change="handler().getUpdateAllQuote(0)" />
            <!-- <v-input
              v-model="filterData.isrd_vl"
              append="HKD"
              @keyEnter="handler().getUpdateAllQuote(0)" />
            <span class="mini">minimum sum insured 100,000HKD</span> -->
            </div>
          </div>
          <div
            v-if="classId !== 14"
            class="card">
            <div class="form-item">
              <span>More Benefits</span>
              <v-checkbox-group
                v-model="filterData.benefit"
                :list="benefitsList"
                @change="handler().getUpdateAllQuote(0)" />
            </div>
          </div>
          <div class="card">
            <div class="form-item">
              <span>Company</span>
              <v-checkbox-group
                v-model="filterData.company"
                :block="true"
                :list="companyList"
                @change="handler().getUpdateAllQuote(0)" />
            </div>
          </div>
        </div>
        <div class="main-content">
          <quote-plan-list
            :allQuoteList="allQuoteList"
            :quoteDetailData="quoteDetailData"
            :classId="classId"
            :shortlist="shortlist"
            :detail_b="detail_b"
            :list_b="list_b"
            :type="type"
            :isRenew="isRenew"
            @select-policy="handleSelect"
            @get-reference-quote="handlerGetReferenceQuote"
            @buy-policy="handlerBuyPolicy" />
        </div>
      </div>
    </template>
    <section v-if="step === 1">
      <div class="flex-sb">
        <div class="flex-1 mg-r-15">
          <policy-information
            ref="policy-information"
            :form="quoteData" />
        </div>
        <plan-info
          codeType="refer"
          :form="quoteData"
          :is-fina="isFina"
          @apply="handlerApplyCode" />
      </div>
    </section>
    <section v-if="step === 2">
      <payment
        :orderId="orderId"
        :form="quoteData"
        :is-fina="isFina"
        @apply="handlerApplyCode"
        @pre="changeStep(-1)" />
    </section>

    <buy-policy-tips
      ref="buy-policy-tips"
      :classId="classId"
      :under-list="underList"
      @confirm="confirmBuyPolicy" />
    <select-send-message
      ref="auto-renew-email-sms"
      v-model="showAutoCloseSelectMessage"
      :form="referDetail"
      :initSmsContent="auto_renew_close_data"
      :init-email-content="email_auto_renew_close_data"
      :init-share-content="share_auto_renew_close_data"
      :init-refer-content="auto_renew_close_data"
      :is-only-referrer="isFina"
      :updateContent="true"
      @send="handlerRenewSend"
      @skip="handlerRenewSkip"/>
  </section>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import {getReferralBuyQuote, referQuoteApplyCode, referralBuyPolicy} from '@/api/refer'
import {
  getQuoteReference,
  getQuoteDetail
} from '@/api/quote'
import {saveReferCaseOrder} from '@/api/order'
import MixinOptions from '@/mixins/options'
import QuotePlanList from '@/views/quoting/components/quote-plan-list'
import BuyPolicyTips from '@/views/quoting/dialogs/buy-policy-tips'
import PolicyInformation from './policy-information'
import PlanInfo from '@/views/components/plan-info'
import Payment from './payment'
import CodeSelect from '@/views/components/code-select'
import {downloadFile} from '@/utils/download'
import {renewBuyPolicy, renewBuyQuoteList} from '@/api/renewal'
import {getSMEQuoteDetail} from '@api/sme'
import SelectSendMessage from '@/views/components/dialogs/select-send-message'
export default {
  name: 'BuyQuoteContainer',
  components: {
    QuotePlanList,
    BuyPolicyTips,
    PolicyInformation,
    PlanInfo,
    Payment,
    CodeSelect,
    SelectSendMessage
    // PromoCode
  },
  mixins: [MixinOptions],
  props: {
    customerId: {
      type: [String, Number],
      default: ''
    },
    customerProfile:{
      type:[Object,Array],
      default:()=>({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    referDetail: {
      type: Object,
      default: () => ({})
    },
    isRefer: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    },
    isRenew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      plan:{},
      showAutoCloseSelectMessage:false,
      step: 0, // 0-獲取報價，1-購買，2-支付
      buyIndex: -1,
      quoteData: {},
      allQuoteList: [],
      filterData: {
        benefit: [],
        company: [],
        // isrd_vl: '',
        trm_of_cvr: []
      },
      code: '',
      quoteDetailData: [],
      shortlist: [],
      detail_b: [],
      list_b: [],
      form11: {
        brand_id: '',
        model_id: '',
        typ_of_bdy_id: '',
        engn_cpcty: '',
        rgtn_yr: '',
        ncd_pct: '',
        benefits: [],
        trm_of_cvr: 1,
        isrd_vl: '',
        no_of_nm_drvr: 1,
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:''
          }
        ],
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        enough_age_ind: '',
        enough_exp_ind: '',
      },
      form12: {
        brand_id: '',
        tonnage: '',
        typ_of_bdy_mix_id : '',
        rgtn_yr: '',
        ncd_pct: '',
        benefits: [],
        trm_of_cvr: 0,
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        isrd_vl: '',
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:''
          }
        ],
        enough_age_ind: '',
        enough_exp_ind: '',
        use_carrying_profit_ind: ''
      },
      form14: {
        trm_of_cvr: 1,
        brand_id: '',
        typ_of_bdy_id: '',
        engn_cpcty: '',
        rgtn_yr: '',
        ncd_pct: '',
        usage_ind: '',
        no_of_nm_drvr: 1,
        nm_drvr_list:[
          {
            nm_drvr_age:'',
            nm_drvr_exp:'',
            nm_drvr_acc:'',
            nm_drvr_pt:'',
          }
        ],
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        enough_age_ind: '',
        nm_drvr_age: '',
        dr_lic_of_own: ''
      },
      form21: {
        duty_id: '',
        nature: '',
        nationality_id: '',
        domestic_age: '',
        period_of_cvr: '',
        monthly_salary: '',
        coverage_id: '',
        plan_tier: 1,
        benefits: [],
      },
      form22: {
        plan_tier: 1
      },
      form23: {
        plan_type: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        class_type: 1,
        no_of_traveler:'',
        no_of_child:'',
        area_of_travel :'',
        no_of_adult:'',
        plan_tier: 1
      },
      form24: {
        contr_prd: '',
        bldg_age: '',
        tol_contr_sum: '',
        mat_dam_cvr_ind: '',
        tp_lia_cvr_ind: '',
        tppd_limit_amt: '',
        outdoor_wk_ind: '',
        scaffolding_wk: 0,
        outdoor_wk_sum: '',
        employee_ind: '',
      },
      form25: {
        country_id: '',
        is_full_time: '',
        student_age:'',
        plan_tier: 1
      },
      form26: {
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        coverage_id: '',
        prop_age: '',
        plan_tier: 1,
        benefits: []
      },
      form27: {
        age_id: '',
        occ_id: '',
        plan_tier: 1
      },
      form29: {
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        prop_age: '',
        bsc_sum_insured:'',
        benefits: []
      },
      renewCompanyList: []
    }
  },
  computed: {
    ...mapState('ticket', ['referData']),
    ...mapState('common', ['productId']),
    ...mapState('coupon', ['selectCode']),
    underList(){
      let arr = this.allQuoteList||[]
      let obj = arr[this.buyIndex]||{}
      let {underwriting} = obj||{}
      return  underwriting||[]
    },
    classId() {
      return this.referData && this.referData.class_id || 14
    },
    quoteId() {
      let {quo_id} = this.referDetail
      return quo_id||0
    },
    benefitsList() {
      if(this.classId === 14||this.isSMEProduct) return []
      return this[`allOptions${this.classId}`].benefits
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    customer(){
      let {isrd_nm} =this.referDetail||{}
      return {
        isrd_nm
      }
    },
    type(){
      return this.referDetail.type
    },
    title(){
      return this.type == 20? 'Switch Insurer' : 'Buy Quote'
    },
    isSMEProduct(){
      return this.referData?this.referData.product_id==80:false
    },
    companyList(){
      return this.type == 20? this.renewCompanyList : this.localAllOptions.quote_company || []
    },
    show_auto_reject(){
      let {pre_auto_renewal_info={}} = this.referDetail||{}
      let {disable_on,auto_on } =pre_auto_renewal_info||{}
      return !disable_on&&auto_on&&this.isRenew
    },
    auto_renew_close_data(){
      let {auto_renew_close_data} = this.referDetail||{}
      return auto_renew_close_data
    },
    email_auto_renew_close_data(){
      let {renew_email_data={}} = this.referDetail||{}
      return renew_email_data.auto_renew_close_data||''
    },
    share_auto_renew_close_data(){
      let {share_renew_data={}} = this.referDetail||{}
      let {share_auto_renew_close_data} = share_renew_data||{}
      return share_auto_renew_close_data||''
    },
  },
  watch: {
    referDetail: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val.code) {
          this.code = val.code
        }
        if(val.product_id==80)
          this.step = 2
      }
    }
  },
  created() {
    // 在這裏獲取數據
    if(!this.isSMEProduct)
    {
      this.step = 0
      this.network().getReferralBuyQuote()
    }else{
      this.step = 2
      this.network().getSMEQuoteDetail()
    }
  },
  methods: {
    ...mapActions('coupon', ['setSelectCode']),
    handlerRenewSkip(content,send_type) {
      let params ={}
      params.is_send_sms =0
      params.is_send_email =0
      params.is_share_send =0
      params.content =''
      params.email_content =''
      params.share_content =''
      this.network().renewSelectPlan(this.plan,params)
    },
    handlerRenewSend(data) {
      let params ={}
      let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send} = data ||{}
      params.is_send_sms =is_sms_send
      params.is_send_email =is_email_send
      params.is_share_send =is_share_send
      params.content =content
      params.email_content =email_content
      params.share_content =share_content
      this.network().renewSelectPlan(this.plan,params)
    },
    handlerSetCode(){
      let {coupon,code,coupon_code,referrer,referrer_id,referrer_user_id,sidebar_info} = this.quoteData||{}
      let params = {}
      if(this.isSMEProduct){
        coupon_code = sidebar_info.coupon_code
        code = sidebar_info.code
      }
      if(coupon_code){
        if(this.isSMEProduct){
          coupon = {
            title:coupon_code,
            coupon_code
          }
        }
        params.coupon = {selectCode:1,...coupon}
        // this.setSelectCode ({selectCode:1,...coupon})
      }
      if(code||this.isFina&&referrer.code){
        params.code ={selectCode:2,code:this.isFina?referrer.code:code,referrer,referrer_user_id}
        // this.setSelectCode({selectCode:2,code})
      }
      this.setSelectCode(params)
    },
    changeStep(value) {
      if(this.isSMEProduct)
      {
        this.handleBack()
        return
      }
      this.step += value
      if(this.step == 0){
        this.network().getReferralBuyQuote()
      }
    },
    handlerGetOrderDetail(){
      this.network().getOrderDetail()
    },
    async handlerNext() {
      if(this.type == 20){
        this.step = 2
        return
      }
      // 更新投保資料
      const documentParams = await this.$refs['policy-information'].submitForm()
      if(!documentParams) return

      this.network().saveOrder(documentParams)
    },
    handleBack(){
      this.$emit('back')
    },
    handlerBuyPolicy(index) {
      this.buyIndex = index
      // this.$refs['buy-policy-tips'].changeDialog()
      this.confirmBuyPolicy()
    },
    handleSelect(plan){
      let {quo_id} = plan||{}
      if((quo_id!=this.quoteId)&&this.show_auto_reject){
        this.plan = plan
        this.showAutoCloseSelectMessage = true
      }
      else
        this.network().renewSelectPlan(plan)
    },
    confirmBuyPolicy() {
      let {selectCode, code, coupon} = this.selectCode||{}
      let params = {}
      // if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
      // if(code&&code.selectCode==2)params.code = code&&code.code
      this.network().referralBuyPolicy(params)
    },
    handlerGetAllQuote() {
      this.network().getReferralBuyQuote()
      // if(this.selectCode) {
      // let {selectCode, code, coupon_code} = this.selectCode||{}
      // if (selectCode === 1)
      // {
      //   this.network().getReferralBuyQuote({coupon_code})
      //
      // }
      // else if(selectCode == 2)
      //   this.network().getReferralBuyQuote({code})
      // else{
      //
      //   // this.network().getReferralBuyQuote({
      // }
      // this.network().referQuoteApplyCode(params)
      // this.network().getReferralBuyQuote({
      //   code,
      // })
    },
    handlerApplyCode() {
      if(this.productId==80){
        this.network().getSMEQuoteDetail()
      }else this.network().getQuoteDetail()
    },
    handlerGetReferenceQuote(index, url) {
      const {class_id, quo_id, company_id} = this.allQuoteList[index].plan_info
      let obj = {}
      if(this.isRenew){
        obj = this[`form${class_id}`]
        Object.keys(obj).forEach(key => {
          obj[key] = this.referDetail[key]
        })
      }
      const data = {
        class_id,
        quo_id,
        company_id,
        ...obj
      }
      this.network().getQuoteReference(url,data)
    },
    handler() {
      return {
        getUpdateAllQuote: () => {
          this.network().getReferralBuyQuote()
        }
      }
    },
    network() {
      return {
        getOrderDetail(){
          this.network().getQuoteDetail()
        },
        // 獲取報價
        getReferralBuyQuote: async (params = {}) => {
          // const { trm_of_cvr = [], isrd_vl } = this.filterData
          // if(trm_of_cvr.includes(2) && !isrd_vl) {
          //   this.$message({
          //     type: 'warning',
          //     message: '請填寫車輛投保額'
          //   })
          //   return
          // }
          let {selectCode, code, coupon} = this.selectCode||{}
          if(!this.isFina)
          {
            if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
            if(code&&code.selectCode==2)params.code = code&&code.code
          }
          if(this.type == 20){
            let params = {}
            Object.assign(params, this.filterData)
            delete params.trm_of_cvr
            var { data } = await renewBuyQuoteList({
              order_id: this.orderId,
              ...params
            })
            this.renewCompanyList = data.filter_company || []
          }else{
            var { data } = await getReferralBuyQuote({
              ...params,
              refer_id: this.referData.refer_id,
              // code: this.code,
              ...this.filterData
            })
          }
          this.allQuoteList = data.list
          this.quoteDetailData = data.detail
          this.shortlist = data.shortlist
          this.detail_b = data.detail_b
          this.list_b = data.list_b
        },
        referralBuyPolicy: async () => {
          // let {selectCode, code, coupon} = this.selectCode||{}
          let params = {}
          // if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
          // if(code&&code.selectCode==2)params.code = code&&code.code
          const { data } = await referralBuyPolicy({
            quo_id: this.allQuoteList[this.buyIndex].plan_info.quo_id||0,
            ...params
          })

          this.step = 1
          // 獲取報價詳情數據
          this.network().getQuoteDetail()
        },
        renewSelectPlan: async (plan,param) => {
          let quo_id = plan.quo_id
          let company_id = plan.company_id
          let plan_id = plan.plan_id
          let params = {
            quo_id,
            company_id,
            plan_id,
            order_id: this.orderId,
            ...param
          }
          const { data } = await renewBuyPolicy(params)
          if(data.message == 'Success'){
            let path = this.isFina?'/quoting/referrer/send/payment':'/quoting/payment/success'
            this.$router.push({
              path:path,
              query: {
                order_id: this.orderId,
                product_id: this.productId,
                customer_id: this.customerId,
                quote_no: this.referDetail.quotation_number,
                type: 'renew'
              }
            })
          }
        },
        getQuoteDetail: async () => {
          const { data } = await getQuoteDetail({
            order_id: this.orderId
          },this.productId)
          this.quoteData = data
          this.handlerSetCode()
          // this.code = data.code
        },
        getSMEQuoteDetail:async ()=>{
          let {data} = await getSMEQuoteDetail({
            order_id:this.orderId
          },this.classId)
          this.quoteData = data
          this.handlerSetCode()
        },
        saveOrder: async params => {
          // const { data } = await saveOrder({
          const { data } = await saveReferCaseOrder({
            ...this.quoteData,
            ...params,
            order_id: this.quoteData.id
          })
          this.step = 2
        },
        referQuoteApplyCode: async (params = {}) => {
          const { data } = await referQuoteApplyCode({
            refer_id: this.referData.refer_id,
            ...params
          })
          // console.log('params--',params)
          // this.allQuoteList = data
          this.allQuoteList = data.list
          this.quoteDetailData = data.detail
          // this.quoteData = Object.assign(this.quoteData, data)
          // this.network().getReferralBuyQuote()
        },
        getQuoteReference: async (url, params) => {
          const res = await getQuoteReference(url, params)
          downloadFile(res)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.buy-quote-container {
    position: relative;
    padding: 10px 20px 15px 20px;
    .abs-top-right {
        padding: 15px 15px 0 0;
    }
    .main-container {
    display: flex;
    margin-top: 10px;
    .left {
      width: 200px;
      margin-right: 15px;
      .mini {
        color: #91939a;
        font-size: 12px;
        line-height: 14px;
      }
    }
    .main-content {
      flex: 1;
      .plan-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding: 15px;
        border-radius: 4px;
        background: white;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .left {
          width: 130px;
          text-align: center;
          .logo {
            display: block;
            margin-top: 10px;
            width: 120px;
            height: 64px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          margin: -15px -15px -15px 0;
          padding-left: 10px;
          width: 140px;
          background: #f4f4f5;
          .span-top {
            position: absolute;
            top: 15px;
            left: 15px;
            display: block;
            padding: 5px 10px;
            border: 1px solid #faecd8;
            border-radius: 4px;
            background: #fdf6ec;
            font-size: 12px;
            color: #e6a23c;
          }
          .amount {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: #409eff;
          }
          .unit {
            color: #616266;
            font-size: 12px;
          }
          .el-button {
            position: absolute;
            bottom: 15px;
            left: 15px;
          }
        }
        .middle {
          flex: 1;
          position: relative;
          padding-right: 10px;
          .abs-top-right {
            right: 15px;
          }
          .title {
            padding-right: 90px;
            font-size: 20px;
            color: #616266;
            font-weight: bold;
          }
          .flex {
            justify-content: space-between;
            .table {
              flex: 1;
              .table-title {
                font-size: 12px;
                font-weight: bold;
                color: #909399;
              }
              &:first-child {
                margin-right: 15px;
                .tr {
                  span:first-child {
                    width: 115px;
                  }
                }
              }
              &:last-child {
                .tr {
                  span:first-child {
                    width: 130px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
